module.exports = __webpack_public_path__ + "static/media/Indorse-Белая-Книга-v1.1.a733cc8e.5f2299a9.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/resources/brand/Indorse-Белая-Книга-v1.1.a733cc8e.pdf
// module id = 1283
// module chunks = 147